<style lang="less" scoped>
@import "../index.less";
</style>

<template>
  <el-card>
    <div slot="header">
      <div class="order-info">
        <span class="order-orderSn">订单号：{{order.orderSn}}</span>
        <span v-if="isRefund" class="order-date">申请时间：{{ order.refundRecord  && order.refundRecord.createdAt}}</span>
        <span v-else class="order-date">下单时间：{{order.createdAt}}</span>
        <router-link :to="{ name: 'member-order-detail', params:{ id : order.id}}">
          订单详情
        </router-link>
      </div>
      <div v-if="isRefund">
        退款单状态：{{getRefundOrderStatus(order)}}
      </div>
      <div v-else class="order-status">
        订单状态：{{getOrderStatus(order)}}
      </div>
    </div>
    <div class="member-order-list">
      <div class="order-list">
        <el-table
          class="table"
          :data="order.orderProducts"
          :show-header="false"
        >
          <el-table-column>
            <template slot-scope="scope">
              <div class="order-product-item">
                <div class="order-product-image">
                  <img
                    :src="scope.row.image"
                    alt=""
                    class="member-order-image"
                  >
                </div>
                <div class="order-product-info order-product-name-info">
                  <div class="order-product-name">{{scope.row.productName}}</div>
                  <div class="order-product-mark">{{$enums.productMark.label(scope.row.mark)}}</div>
                </div>
                <div class="order-product-info order-product-price text-center">
                  ¥ {{ scope.row.salePrice }}
                </div>
                <div class="order-product-info order-product-number text-center">
                  {{ scope.row.number }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="order-price">
        <div>¥ {{order.orderAmount}}</div>
        <!-- <div class="text-center" style="color: red">{{getOrderStatus(order)}}</div> -->
      </div>
      <div class="order-payment">
        <el-button
          type="primary"
          :disabled="disable"
          @click="payOrder(order)"
          v-if="showOrderPayment(order)"
        >
          付款 <span>{{cancelTimeDesc}}</span>
        </el-button>
        <el-button
          type="text"
          style="margin-top:15px"
          @click="cancelOrder(order)"
          v-if="showOrderPayment(order)"
        >
          取消订单
        </el-button>

        <el-button
          type="primary"
          @click="receiveOrder(order)"
          v-if="showOrderReceive(order)"
        >
          签收
        </el-button>
        <div v-if="isRefund">
          <router-link
            class="text-df"
            :to="{ name: 'member-order-refund-detail', params:{ id : order.id}}"
          >
            退款详情
          </router-link>
        </div>
        <router-link
          v-if="showCompleteInfo(order) && isRefund"
          class="text-df"
          :to="{ name: 'member-order-refund-detail', params:{ id : order.id, type: 'shipped'}}"
        >
          完善寄回信息
        </router-link>
        <div
          class="flex col flex-cc"
          v-if="showOrderRefundProgress(order)"
        >

          <router-link
            class="text-df"
            :to="{ name: 'member-order-refund-detail', params:{ id : order.id, type: 'unshipped'}}"
            v-if="!isRefund"
          >
            查看退款进度
          </router-link>
          <a
            @click="cancelRefund"
            class="text-df margin-top"
            v-if="isRefund"
          >
            取消退款
          </a>
        </div>
        <router-link
          v-if="showOrderRefund(order) && !isRefund"
          class="text-df"
          :to="{ name: 'member-order-refund', params:{ id : order.id, type: 'unshipped'}}"
        >
          申请退款
        </router-link>
        <router-link
          v-if="showOrderRefundAndShop(order) && !isRefund"
          class="text-df"
          :to="{ name: 'member-order-refund', params:{ id : order.id}}"
        >
          申请退货退款
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { payOrder, getOrderStatus } from "@/helpers/index";
const { mapState, mapActions } = createNamespacedHelpers('refund')


export default {
  name: 'OrderListItem',
  components: {
  },
  data() {
    return {
      cancelTime: 0,
      cancelTimeDesc: '',
      disable: false,
      returnEnable: 0,
      refundEnable: 0
    }
  },
  props: {
    order: {
      required: true
    },
    isRefund: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.handleOrderCancelTime()
    this.returnEnable = localStorage.getItem('activity') ? JSON.parse(localStorage.getItem('activity')).returnEnable : 0
    this.refundEnable = localStorage.getItem('activity') ? JSON.parse(localStorage.getItem('activity')).refundEnable : 0
  },
  updated() {

  },
  methods: {
    ...mapActions(['changeRefundOrderStatus']),
    payOrder(order) {
      payOrder(this.$router, order)
    },

    async cancelRefund() {
      try {
        await this.$confirm('确定取消当前退款申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        await this.changeRefundOrderStatus({
          id: this.order.refundRecord.id,
          status: this.$enums.refundStatus.RO_CANCELLED
        })
        this.$emit('getOrders')
      } catch(error) {
        this.$emit('getOrders')
      }
    },

    /**
     * 处理订单自动关闭时间
     */
    handleOrderCancelTime() {
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if (orderCancelTime == 0 || order.orderStatus != this.$enums.orderStatus.UNSETTLED) {
        this.cancelTimeDesc = '';
        return;
      }
      setInterval(this.getOrderCancelTime, 1000)

    },

    /**
     * 订单自动关闭时间
     */
    getOrderCancelTime() {
      let order = this.order
      let orderCancelTime = parseInt(this.order.activity.cancelTime) * 60 * 1000
      if (this.cancelTime != 0) {
        orderCancelTime = this.cancelTime--;
      } else {
        let currentTime = new Date().getTime();
        let orderCreateTime = new Date(order.createdAt).getTime()
        orderCancelTime = parseInt(orderCancelTime) - (currentTime - orderCreateTime)

        if (orderCancelTime <= 0) {
          this.cancelTimeDesc = ''
          this.cancelTime = 0;
          this.disable = true;
          return
        }
        orderCancelTime = orderCancelTime / 1000
        this.cancelTime = parseInt(orderCancelTime)
      }

      let minutes = parseInt(orderCancelTime / 60)
      let seconds = parseInt(orderCancelTime % 60)

      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      this.cancelTimeDesc = minutes + ":" + seconds;
    },

    getRefundOrderStatus(order) {
      if (!order ||!order.refundRecord) return ''
      return this.$enums.refundStatus.label(order.refundRecord.status)
    },

    /**
     * 获取订单状态
     */
    getOrderStatus(order) {
      return getOrderStatus(this.$enums, order)
    },

    /**
     * 是否显示支付链接
     */
    showOrderPayment(order) {
      if (order.orderStatus == this.$enums.orderStatus.CANCELLED || order.orderStatus == this.$enums.orderStatus.COMPLETED || order.payStatus != this.$enums.payStatus.UNPAID) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 是否显示签收按钮
     */
    showOrderReceive(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING &&
        order.shippingStatus == this.$enums.shippingStatus.SHIPPED &&
        order.payStatus == this.$enums.payStatus.PAID) {
        return true
      }
      return false
    },

    /**
     * 是否显示申请退款按钮
     */
    showOrderRefund(order) {
      if (order.orderStatus == this.$enums.orderStatus.ACCEPTED && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.UNSHIPPED && this.refundEnable) {
        return true;
      }
      return false
    },
    showOrderRefundAndShop(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.SHIPPED&&this.returnEnable&&order.can_refund) {
        return true;
      }
      if (order.orderStatus == this.$enums.orderStatus.COMPLETED && order.payStatus == this.$enums.payStatus.PAID && order.shippingStatus == this.$enums.shippingStatus.SIGN&&this.returnEnable&&order.can_refund) {
        return true;
      }
      return false
    },
    /**
     * 是否显示完善信息按钮
     */
    showCompleteInfo(order) {
      if (order.refundRecord&&order.refundRecord.status === 4) return true
      return false
    },
    /**
     * 是否显示查看退款进度
     */
    showOrderRefundProgress(order) {
      if (order.orderStatus == this.$enums.orderStatus.PENDING && order.refundRecord) {
        return true
      }
      return false
    },

    /**
     * 取消订单
     * @param order 订单数据
     * @param isConfirm 是否显示确认框
     * @returns {Promise<void>}
     */
    async cancelOrder(order, isConfirm) {
      if (!isConfirm) {
        await this.$confirm('是否确认取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }

      await this.$store.dispatch('order/cancel', { id: order.id });
      this.$emit('cancelOrder')
    },

    async receiveOrder(order, isConfirm) {
      if (!isConfirm) {
        await this.$confirm('确认签收当前订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }

      await this.$store.dispatch('order/receive', { id: order.id });
      this.$emit('cancelOrder')
    },

  },
}
</script>


